export default __webpack_public_path__ + "static/media/triobanner.396dd117.png";